export const CouncilColLayout = '172px 172px 172px 72px'
